import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import Numbers from "../../services/numbers.service";
import User from "../../services/user.service";
import Plans from "../../services/plans.service";
import Storage from "../../services/storage.service";
import HTTP from "../../services/http.service";
import storefront from "../../services/storefront.service";
import Skeleton from "../skeleton/dropOffModal"
import Data from "../../assets/img/stm-data.svg";
import Summaries from "../../services/summaries.service";
import * as variables from '../../variables';
import Helpers from "../../helpers/shared.helper";
import Settings from "../../services/settings.service";
import infinity from "../../assets/img/blackInfinity.svg";
import FirebaseAnalytics from "../../services/firebaseAnalytics";
import CONSTANTS from "../../services/constants.service";

const subscriptions = [];
let prefix = "stm_sum_";
let prefix_general = "stm_general_";
const DropOffModal = (props) => {
  const [translationsKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [displayModal, setDisplayModal] = useState(true);
  const [reservedNumber, setReservedNumber] = useState(
    Storage.get("reserved_number_local")
  );
  const [reservedNumberDetail, setReservedNumberDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [flag, setFlag] = useState(false);
  const [localMin, setLocalMin] = useState(null);
  const [planData, setPlanData] = useState(null);

  const [minutesBonusValues, setMinutesBonusValues] = useState([]);
  const [dataBonusValues, setDataBonusValues] = useState({});
  const [addonsValues, setAddonsValues] = useState({});
  console.log("reservedNumber===>", reservedNumberDetail, flag)

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  useEffect(() => {
    getNumber();
  }, []);

  const getNumber = () => {
    setLoading(true);
    User.getFlowStatus()
      .then((response) => {
        let flagData = response.data?.flow_status_flags;
        setFlag(flagData);
        subscriptions.push(
          Storage.get_obsrv("vanity_details").subscribe((data) => {
            if (data) {
              if (flagData?.PaymentPending || flagData?.NumberPaymentPending) {
                Numbers.postProcessReservedNumber()
                  .then((response) => {
                    let getreservedNumber = Storage.get(
                      "reserved_number_local"
                    );
                    setReservedNumber(Storage.get("reserved_number_local") ?JSON.parse(Storage.get("reserved_number_local")): "");
                    let proccessVanityNumber = Plans.proccessVanityNumberDataKW(
                      getreservedNumber.VanityLevelId
                    );
                    setReservedNumberDetail({
                      color: proccessVanityNumber.style_value,
                      vanityName: proccessVanityNumber.nameKey,
                      subname: proccessVanityNumber.subnameKey,
                    });
                    setLoading(false);
                  })
                  .catch((err) => {
                    setLoading(false);
                  });
              } else {
                Numbers.postProcessCommitedNumber("2")
                  .then((response) => {
                    setReservedNumber({
                      MSISDN: response?.data?.numbers[0].MSISDN,
                    });
                    let proccessVanityNumber = Plans.proccessVanityNumberDataKW(
                      response?.data?.numbers[0].VanityLevelId
                    );
                    setReservedNumberDetail({
                      color: proccessVanityNumber.style_value,
                      vanityName: proccessVanityNumber.nameKey,
                      subname: proccessVanityNumber.subnameKey,
                    });
                    setLoading(false);
                  })
                  .catch((err) => {
                    setLoading(false);
                  });
              }
            } else {
              Storage.getOrfetch("vanity_details", Numbers.vanity_details)
                .then((dataVanity) => {
                  if (dataVanity["data"]) {
                    Numbers.process_vanity_details(dataVanity.data);
                    if (flagData?.PaymentPending) {
                      Numbers.postProcessReservedNumber()
                        .then((response) => {
                          let getreservedNumber =
                            Storage.get("reserved_number_local");
                          setReservedNumber(Storage.get("reserved_number_local") ?JSON.parse(Storage.get("reserved_number_local")): "");
                          let proccessVanityNumber =
                            Plans.proccessVanityNumberDataKW(
                              getreservedNumber.VanityLevelId
                            );
                          setReservedNumberDetail({
                            color: proccessVanityNumber.style_value,
                            vanityName: proccessVanityNumber.nameKey,
                            subname: proccessVanityNumber.subnameKey,
                          });
                          setLoading(false);
                        })
                        .catch((err) => {
                          setLoading(false);
                        });
                    } else {
                      Numbers.postProcessCommitedNumber("2")
                        .then((response) => {
                          setReservedNumber({
                            MSISDN: response?.data?.numbers[0].MSISDN,
                          });
                          let proccessVanityNumber =
                            Plans.proccessVanityNumberDataKW(
                              response?.data?.numbers[0].VanityLevelId
                            );
                          setReservedNumberDetail({
                            color: proccessVanityNumber.style_value,
                            vanityName: proccessVanityNumber.nameKey,
                            subname: proccessVanityNumber.subnameKey,
                          });
                          setLoading(false);
                        })
                        .catch((err) => {
                          setLoading(false);
                        });
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                });
            }
          })
        );
      })
      .catch((error) => {});

    setLoading(false);
  };

  const getColorFromVanity = (Vanitylevel) => {
    // GET VANITY COLOR
    let style = {};
    let theme = Storage.get("theme", true);
    let vanity_theme = "vanity_level";
    let theme_parsed = JSON.parse(theme);
    if (theme && vanity_theme && theme_parsed) {
      let style_value_comp = vanity_theme + Vanitylevel;
      if (style_value_comp) {
        let style_value = theme_parsed[style_value_comp];
        style["color"] = style_value;
      }
    }
    return style;
  };

  const cancelDropOffJourney = () => {
    FirebaseAnalytics.button_clicked( CONSTANTS.DROP_OFF_MODAL, translationsKeys["ob_drop_off_cancel"])
    setLoading(true);
    HTTP.set_session("");
    Storage.clear("session");
    localStorage.clear();
    clearWelcomeBack();
    window.location.reload(false);
  };

  const continueJourney = () => {
    FirebaseAnalytics.button_clicked( CONSTANTS.DROP_OFF_MODAL, translationsKeys["ob_drop_off_continue"])
    clearWelcomeBack();
    setDisplayModal(false);
    window.location.reload(false);
  };

  const clearWelcomeBack = () => {
    localStorage.removeItem("WelcomeBack");
    localStorage.removeItem("ReloadedOrLeft");
    localStorage.removeItem("PageReloaded");
    localStorage.removeItem("TabSwitched");
    sessionStorage.removeItem("TabSwitchedBack");
  };


  const getPlanMinuteValue = (plan, type) => {
    let value = "";
    if (plan?.Plans?.length) {
        plan.Plans.forEach((data) => {
            if (data?.Type === type) {
                value = data?.Value !== -1
                    ? Helpers.milisecondstoMinutes(data?.Value)
                    : 0;
            }
        })
    }
    return value;
}

const getPlanDataValue = (plan, type) => {
  let value = "";
  if (plan?.Plans?.length) {
      plan.Plans.forEach((data) => {
          if (data?.Type === type) {
              value = data?.Value !== -1
                  ? Helpers.bytesToGBs(data?.Value)
                  : 0;
          }

      })
  }
  return value;

}

  useEffect(() => {
    setLoading(true);
    Summaries.getSummary()
        .then((res) => {
            if (res?.data) {
                if (res?.data?.saved_plans[0]["Plans"]?.length) {
                    let localMinutes = getPlanMinuteValue(res?.data?.saved_plans[0], "VOICE-LCL");
                    setLocalMin(localMinutes)
                    let data = getPlanDataValue(res?.data?.saved_plans[0], "DATA");
                    setPlanData(data);
                }
                let dataBonus = [];
                let minutesBonus = [];
                let freeAddons = [];
                let selectedPlanPromotions = res?.data?.saved_plans[0]?.PlanPromotions
                if (Array.isArray(selectedPlanPromotions) && selectedPlanPromotions.length && Settings.enable_free_plan) {
                    const freePlanPromotions = selectedPlanPromotions.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
                    for (let promotion of freePlanPromotions) {
                        const parsed = JSON.parse(promotion["Value"]);
                        switch (parsed.Type) {
                          case variables.PROMOTION_TYPE_VOICE_ON_NET:
                          case variables.PROMOTION_TYPE_DATA_SOCIAL:
                          freeAddons.push(parsed);
                          break;
                            case variables.PROMOTION_TYPE_DATA:
                                dataBonus.push(parsed);
                                break;
                            case variables.PROMOTION_TYPE_VOICE_LCL:
                                minutesBonus.push(parsed);
                                break;
                            default:
                        }
                    }
                }
                let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
                setDataBonusValues(dataBonusValues)
                let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
                setMinutesBonusValues(minutesBonusValues)
                let freeAddonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb");
                setAddonsValues(freeAddonsValues)
            }
            setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
}, []);
  return (
    <>
      {displayModal && (
        <div className="dialog dialog-ob-modal">
          <div className="dialog-modal-container-ob">
            {loading || !translationsKeys["kw_your"] ? (
              <Skeleton/>
            ) : (
              <>
                <div className="ob-modal-title">
                  {translationsKeys["ob_drop_off_welcome_back"]}
                  <button
                    className="close-icon"
                    onClick={cancelDropOffJourney}
                  />
                </div>
                <div className="ob-modal-content-wrapper">
                <div className="ob-modal-subtitle">
                  {translationsKeys["ob_drop_off_welcome_back_msg"]}
                </div>

                <div className="ob-modal-active-service">
                  <div className="ob-modal-active-number">
                    {reservedNumber?.MSISDN && (
                      <div className="number-selection-container stm-number-card-btn">
                        <div className="details-container">
                          <img
                            className="badge-section"
                            src={storefront.getPoImage(
                              "stf_vanity_img",
                              `stf_vanity_${reservedNumber.VanityLevelId}`
                            )}
                            alt=""
                          />
                          <div className="details-section">
                            <div className="number-section">
                              {Numbers.get_number_pieces(
                                reservedNumber.MSISDN,
                                reservedNumber.VanityLevelId,
                                null,
                                getColorFromVanity(reservedNumber.VanityLevelId)
                              )}
                            </div>
                            <p
                              className="number-text"
                              style={getColorFromVanity(
                                reservedNumber.VanityLevelId
                              )}
                            >
                              {
                                translationsKeys[
                                  `general_vanity_name_${reservedNumber.VanityLevelId}number`
                                ]
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    
                  </div>
                  <div className='stm-sum-wrapper'>
                  <div className='stm-act-card'>
                        <div className="stm-act-logo">
                            <img src={Data} alt="" />
                            <span>{Translations.keys["scr_3.10_A_signup_step_plan_name"]}</span>
                        </div>
                        <div div className='stm-act-grid'>
                            {minutesBonusValues !== 0 || localMin !== 0 ?
                                <>
                                    <div className="stm-act-block-left">
                                        {Translations.keys[prefix_general + "minutes"] + " "} / 2X
                                        {" " + Translations.keys[prefix + "sms"]}</div>
                                    <div className="stm-act-block-right">
                                        {localMin < 0 || minutesBonusValues < 0 ?
                                            <img src={infinity} alt="infinity"/>
                                            : localMin + minutesBonusValues}
                                        {" " + Translations.keys[prefix_general + "minute_unit"]}</div></> : null}

                            {dataBonusValues !== 0 || planData !== 0 ? <>
                                <div className="stm-act-block-left">{" " + Translations.keys[prefix_general + "data"]}</div>
                                <div className="stm-act-block-right">
                                    {planData < 0 || dataBonusValues < 0 ?
                                        <img src={infinity} alt="infinity"/>
                                        : planData + dataBonusValues}
                                    {" " + Translations.keys[prefix_general + "data_unit"]}</div>
                            </> : null}
                            {addonsValues !== 0  ? <>
                                <div className="stm-act-block-left">{" " + Translations.keys["free_addons_lbl_DATA-SOCIAL"]}</div>
                                <div className="stm-act-block-right">
                                    {addonsValues < 0 ?
                                    <img src={infinity} alt="infinity"/>
                                       : addonsValues?.toString()}
                                    {" " + Translations.keys[prefix_general + "data_unit"]}</div>
                            </> : null}
                        </div>
                    </div>
                    </div>
                </div>

                <div className="ob-modal-action-button">
                  <div
                    className="common-simple-button"
                    onClick={cancelDropOffJourney}
                  >
                    {translationsKeys["ob_drop_off_cancel"]}
                  </div>
                  <button
                    className="common-confirm-button"
                    onClick={continueJourney}
                  >
                    {translationsKeys["ob_drop_off_continue"]}
                  </button>
                </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DropOffModal;
